import { useRef } from "react";
import { NumberInput, NumberInputProps } from "@mantine/core";

export function IMESafeNumberInput(props: NumberInputProps) {
  const composingRef = useRef(false);
  const { onChange, onCompositionStart, onCompositionEnd, ...rest } = props;

  return (
    <NumberInput
      {...rest}
      onCompositionStart={(e) => {
        composingRef.current = true;
        onCompositionStart?.(e);
      }}
      onCompositionEnd={(e) => {
        composingRef.current = false;
        const raw = (e.target as HTMLInputElement).value ?? "";
        const cleaned = raw.replace(/[^\d.-]/g, "");
        if (cleaned === "" || cleaned === "-" || cleaned === ".") {
          onChange?.("" as any);
        } else {
          const parsed = Number(cleaned);
          if (!Number.isNaN(parsed)) {
            onChange?.(parsed as any);
          }
        }
        onCompositionEnd?.(e);
      }}
      onChange={(value) => {
        if (!composingRef.current) {
          onChange?.(value);
        }
      }}
    />
  );
}
